require('./bootstrap-msg.scss');
export default from './bootstrap-msg';